var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list[data-v-c3e1cac2] {\n  display: flex;\n  justify-content: flex-end;\n}\n.apple[data-v-c3e1cac2] {\n  width: 40px;\n  height: 40px;\n  background-image: url(" + escape(require("../assets/apple.svg")) + ");\n  background-size: 40px 40px;\n  position: absolute;\n}\n.apple-fall[data-v-c3e1cac2] {\n  margin-top: 600px !important;\n  transition: margin-top 1s ease-in 0s;\n}\n\n", ""]);

// exports
